import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute, PublicRoute } from "./components/ProtectedRoute";
import { LoginPage, RegisterPage } from "./pages/AuthPages";
import Dashboard from "./pages/Dashboard";
import LandingPage from "./pages/LandingPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import AnalyticsPage from "./pages/AnalyticsPage";
import SharedGoalPage from "./pages/SharedGoalPage";
import AboutPage from "./pages/AboutPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import SupportPage from "./pages/SupportPage";
import RefundPolicyPage from "./pages/RefundPolicyPage";
import AdminRefundPage from "./pages/AdminRefundPage";
import AdminWaitlistPage from "./pages/AdminWaitlistPage";
import WaitlistPage from "./pages/WaitlistPage";
import MyRefundsPage from "./pages/MyRefundsPage";
import AdminHubPage from "./pages/AdminHubPage";
import ProfilePage from "./pages/ProfilePage";
import FriendsPage from "./pages/FriendsPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={
              <PublicRoute>
                <LandingPage />
              </PublicRoute>
            } />
            <Route path="/login" element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            } />
            <Route path="/register" element={
              <PublicRoute>
                <RegisterPage />
              </PublicRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/analytics" element={
              <ProtectedRoute>
                <AnalyticsPage />
              </ProtectedRoute>
            } />
            <Route path="/payment-success" element={
              <ProtectedRoute>
                <PaymentSuccess />
              </ProtectedRoute>
            } />
            <Route path="/my-refunds" element={
              <ProtectedRoute>
                <MyRefundsPage />
              </ProtectedRoute>
            } />
            <Route path="/shared/:shareToken" element={<SharedGoalPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsOfServicePage />} />
            <Route path="/refunds" element={<RefundPolicyPage />} />
            <Route path="/admin/refund" element={<AdminRefundPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/waitlist" element={<WaitlistPage />} />
            <Route path="/admin/waitlist" element={
              <ProtectedRoute>
                <AdminWaitlistPage />
              </ProtectedRoute>
            } />
            <Route path="/admin/hub" element={<ProtectedRoute><AdminHubPage /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
            <Route path="/friends" element={<ProtectedRoute><FriendsPage /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
